module.exports = __webpack_public_path__ + "img/step5.88ce347e.jpg";